import React, { useEffect } from "react";
import { Question } from "../../types";
import { SjtAnswerList } from "./SjtAnswerList";
import { SjtOrderPanel } from "./SjtOrderPanel";
import { getSjtCorrectOrderIds } from "./sjtUtils";

type SjtPracticeBlockProps = {
  question: Question;
  practiceQuestionAnswered: boolean;
  selection: number[];
  delimeters: any[];
  onSelectionChange: (newSelection: number[]) => void;
  onSubmit: (orderedIds: number[]) => void;
  hideBottomSubmitButton?: boolean;
  hideBottomClearButton?: boolean;
};

export const SjtPracticeBlock: React.FC<SjtPracticeBlockProps> = ({
  question,
  practiceQuestionAnswered,
  selection,
  delimeters,
  onSelectionChange,
  onSubmit,
  hideBottomSubmitButton,
  hideBottomClearButton,
}) => {
  const ABCDE = "ABCDE";
  const initialLetterByAnswerId = (() => {
    const map: { [key: number]: string } = {};
    question.answerOptions.forEach((a, i) => {
      map[a.id] = ABCDE[i] || String(i + 1);
    });
    return map;
  })();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (practiceQuestionAnswered) return;
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || (target as any).isContentEditable)) {
        return;
      }
      const upper = e.key?.toUpperCase?.();
      const index = ABCDE.indexOf(upper);
      if (index >= 0 && index < (question.answerOptions?.length || 0)) {
        const ao = question.answerOptions[index];
        if (!selection.includes(ao.id)) {
          onSelectionChange([...selection, ao.id]);
        }
        e.preventDefault();
        return;
      }
      if (e.key === 'Enter') {
        onSubmit(selection);
        e.preventDefault();
        return;
      }
      if (e.key === 'Escape') {
        onSelectionChange([]);
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [practiceQuestionAnswered, question.answerOptions, selection, onSelectionChange, onSubmit]);


  const correctOrder = getSjtCorrectOrderIds(question) || [];
  const maxLen = Math.min(5, correctOrder.length, selection.length);
  let sjtScore = 0;
  for (let i = 0; i < maxLen; i++) {
    if (selection[i] === correctOrder[i]) sjtScore++;
  }

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
        <SjtAnswerList
          question={question}
          practiceQuestionAnswered={practiceQuestionAnswered}
          selection={selection}
          initialLetterByAnswerId={initialLetterByAnswerId}
          delimeters={delimeters}
          onOptionClick={(id) => {
            if (practiceQuestionAnswered) return;
            if (selection.includes(id)) return;
            onSelectionChange([...selection, id]);
          }}
          onClear={() => {
            if (practiceQuestionAnswered) return;
            onSelectionChange([]);
          }}
          onSubmit={() => onSubmit(selection)}
          hideSubmitButton={true}
          hideClearButton={true}
        />
        </div>
      {(practiceQuestionAnswered || selection.length > 0) ? (
        <div style={{ minWidth: 260, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f5f9ff",
              border: "1px solid #d6e6ff",
              borderRadius: 8,
              padding: 12,
              margin: 0,
            }}
          >
            <SjtOrderPanel
              question={question}
              practiceQuestionAnswered={practiceQuestionAnswered}
              selection={selection}
              initialLetterByAnswerId={initialLetterByAnswerId}
            />
            {practiceQuestionAnswered ? (
              <div style={{ marginTop: 10, color: "#444", textAlign: "center", fontSize: 20, fontWeight: 700 }}>
                Score: {sjtScore}/5
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      </div>
      {/* Right-aligned submit on its own line below options */}
      {!practiceQuestionAnswered ? (
        <div style={{ width: "100%", marginTop: 10, display: "flex", justifyContent: "flex-end", gap: 10 }}>
          {hideBottomClearButton ? null : (
            <button
              className="btn btn-danger"
              style={{ display: selection.length === 0 ? "none" : "inline-block" }}
              onClick={() => onSelectionChange([])}
            >
              Clear
            </button>
          )}
          {hideBottomSubmitButton ? null : (
            <button className="btn btn-primary" onClick={() => onSubmit(selection)}>
              Submit answer
            </button>
          )}
        </div>
      ) : null}
    </div>
  );
};


